
export default function RaysVenueSection() {
  return (
    <section className="section-wrap bg-gray-800">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center">
          {/* Left Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-xl shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20sports%20facility%20management%20dashboard%20interface%2C%20smart%20venue%20control%20system%20with%20booking%20calendar%20and%20resource%20management%2C%20clean%20professional%20design%2C%20sports%20facility%20interior%20with%20digital%20displays%20and%20automated%20systems%2C%20white%20background%2C%20technology%20integration%20for%20venue%20operations&width=600&height=400&seq=raysvenue-section&orientation=landscape"
                alt="RaysVenue facility management system interface"
                className="w-full h-auto hover:scale-105 transition-transform duration-500 cursor-pointer object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Venue Features */}
            <div className="absolute bottom-4 left-4 right-4 bg-black/80 backdrop-blur-sm rounded-lg p-4">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-green-500 font-bold text-lg">Smart</div>
                  <div className="text-white text-xs">Booking</div>
                </div>
                <div>
                  <div className="text-green-500 font-bold text-lg">Auto</div>
                  <div className="text-white text-xs">Schedule</div>
                </div>
                <div>
                  <div className="text-green-500 font-bold text-lg">Max</div>
                  <div className="text-white text-xs">Revenue</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            <div>
              <p className="text-orange-500 text-lg font-medium mb-2">Venue Management</p>
              <div className="flex items-center mb-4">
                <img 
                  src="https://static.readdy.ai/image/339666f1cc2ed60abac278570d511bdf/8b40b3e4f93f016360b6626a3dfeca81.png" 
                  alt="Rays Venue Logo" 
                  className="w-12 h-12 object-contain mr-4"
                />
                <h2 className="section-title leading-tight">
                  RaysVenue streamlines sports facility operations and maximizes venue potential
                </h2>
              </div>
            </div>

            <p className="text-gray-300 text-lg leading-relaxed">
              Optimize facility utilization, automate booking processes, 
              enhance customer experience, and drive revenue growth with 
              intelligent venue management that adapts to your facility's 
              unique needs and operational requirements.
            </p>

            <button className="group bg-green-500 hover:bg-green-600 text-black font-semibold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              <span className="relative z-10 flex items-center">
                Explore RaysVenue
                <i className="ri-arrow-right-line ml-2"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
